<template>
    <svg id="Lager_1" data-name="Lager 1" xmlns="http://www.w3.org/2000/svg" version="1.1" viewBox="0 0 11.6999998 11.6999998">
        <line class="cls-1" x1=".1466928" y1="5.8499999" x2="7.676182" y2="5.8499999"/>
        <path class="cls-1" d="M.3107347,7.2136139c.6112277,2.4913801,2.8593982,4.3396931,5.5392652,4.3396931,3.1498495,0,5.7033071-2.5534576,5.7033071-5.7033071S8.9998494.1466928,5.8499999.1466928C3.1701328.1466928.9219624,1.9950059.3107347,4.486386"/>
        <polyline class="cls-1" points="5.4421388 8.0840431 7.676182 5.8499999 5.4421388 3.6159567"/>
    </svg>
</template>
<style scoped>
.cls-1 {
    fill: none;
    stroke: #000;
    stroke-linejoin: round;
    stroke-width: 0.25px;
}
</style>
